import { useQuery } from 'react-query';

import platformService from '../services/platform.service';
import { UserType } from '../users/users.types';

export function useParticipant(): UserType | undefined {
  const { data } = useQuery(['user'], () => platformService.fetchUser());
  return data;
}
